import { css, SerializedStyles } from '@emotion/core';
import { Theme } from 'features/Theme';

const nonEmbeddedStyles = (theme: Theme): SerializedStyles => css`
  border-radius: ${theme.shape.borderRadiusLarge}px;
  border: 1px solid ${theme.mui.palette.divider};
  padding-left: ${theme.mui.spacing(2)}px;
  padding-right: ${theme.mui.spacing(2)}px;

  // So that it does not touch the top bottom of the page
  margin-top: ${theme.mui.spacing(3)}px;
  margin-bottom: ${theme.mui.spacing(3)}px;

  ${theme.mui.breakpoints.up('sm')} {
    padding-left: ${theme.mui.spacing(3)}px;
    padding-right: ${theme.mui.spacing(3)}px;
  }

  ${theme.mui.breakpoints.up('md')} {
    padding-left: ${theme.mui.spacing(5)}px;
    padding-right: ${theme.mui.spacing(5)}px;
  }
`;

const styles = {
  pageContainer: (theme: Theme): SerializedStyles => css`
    label: pageContainer;

    background-color: ${theme.mui.palette.background.paper};

    padding: ${theme.mui.spacing(5)}px ${theme.mui.spacing(0)}px;

    ${theme.mui.breakpoints.up('sm')} {
      padding: ${theme.mui.spacing(5)}px ${theme.mui.spacing(0)}px;
    }

    ${theme.mui.breakpoints.up('md')} {
      padding: ${theme.mui.spacing(5)}px ${theme.mui.spacing(0)}px;
    }
  `,

  bordered: (theme: Theme): SerializedStyles => css`
    ${!theme.embedded && nonEmbeddedStyles(theme)};
  `,
};

export default styles;
